(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3754],{

/***/ 45165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/bundle-pdp",
      function () {
        return __webpack_require__(742);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);



const BundlePdpPage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2374), __webpack_require__.e(3913), __webpack_require__.e(3635), __webpack_require__.e(9328)]).then(__webpack_require__.bind(__webpack_require__, 24738)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(24738)
            ]
    }
});
const ProductDetails = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2374), __webpack_require__.e(3913), __webpack_require__.e(3147), __webpack_require__.e(6514), __webpack_require__.e(9747), __webpack_require__.e(3635), __webpack_require__.e(1045), __webpack_require__.e(3874)]).then(__webpack_require__.bind(__webpack_require__, 73874)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(73874)
            ]
    }
});
const BundlePdp = (props)=>{
    const { isMultiFinishBundle =false  } = props || {};
    return isMultiFinishBundle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BundlePdpPage, {
        ...props
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductDetails, {
        ...props
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (BundlePdp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(45165); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);